export const SESSION_SIGN_IN = 'SERVICES/SESSION/SIGN/IN';
export const SESSION_SIGN_OUT = 'SERVICES/SESSION/SIGN/OUT';
export const SESSION_UPDATE = 'SERVICES/SESSION/UPDATE';
